import { useNavigate } from 'react-router-dom'

export function DashboardESign() {
  const navigate = useNavigate()

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-4'>
            <button 
              onClick={() => navigate('/esign')}
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center gap-2'>
                  <p className='text-xl'>Electronic Signature Needed</p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
            <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
              <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
              <iframe className='w-full aspect-video' src="https://www.loom.com/embed/2d4eeb499df4484c914de1726fc48c3b?sid=700c1ff4-77f1-49a3-9d85-5a65f174f00f&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <p className='font-bold text-xl text-center'>You must complete this step to receive your "Express Refund".</p>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464] text-center'>Click <span onClick={() => navigate('/esign')} className='text-[#FF8C00] underline'>HERE</span> to electronically sign your "Express Refund" agreement.</p>
      </div>
    </div>
  )
}